import { Slug } from "../../../types/thecookies";
import { has_email, has_phone } from "./checkInputs";

function is_containsProtocols(str: string): boolean {
  const regex = /tel:|mailto:|http/;

  return regex.test(str);
}

function setProtocolIfNeeded(str: string): string {
  if (is_containsProtocols(str)) return str;

  if (has_email(str)) return `mailto:${str}`;

  if (has_phone(str)) return `tel:${str}`;

  return str;
}

export function getLink(slug: Slug): string {
  if (typeof slug === "string") {
    if (slug === "/") return "/";
    const slugWithAddedProtocol = setProtocolIfNeeded(slug);
    if (is_containsProtocols(slugWithAddedProtocol)) return slugWithAddedProtocol;

    return `/${slug}/`;
  }

  return slug?.current ? `/${slug.current}/` : "undefined";
}
